import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { CreateRoadmapPanelEntrypointProps } from './CreateRoadmapPanel.entrypoint.types.tsx';

type AsyncCreateRoadmapPanelComponent = EntryPointComponent<
	{},
	{},
	CreateRoadmapPanelEntrypointProps,
	{}
>;

export const createRoadmapPanelAsync: EntryPoint<AsyncCreateRoadmapPanelComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<AsyncCreateRoadmapPanelComponent>(
			/* webpackChunkName: "async-create-roadmap-panel-entrypoint" */ './CreateRoadmapPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
